import { Injectable } from '@angular/core';
import { GridIndexPath, ItemSelectionStore } from '@shared/ui';

import { RoiFilteringEffects } from '../../effects';

export interface RangeExtensionFrameInput {
  indexPaths: GridIndexPath[];
  cellsPerRow: number;
}

@Injectable()
export class RangeExtensionSessionController {
  private active = false;
  private snapshot: ReadonlySet<string> = new Set();

  constructor(
    private readonly itemSelectionStore: ItemSelectionStore,
    private readonly roiFilteringEffects: RoiFilteringEffects
  ) {}

  public start(): void {
    this.snapshot = new Set(this.itemSelectionStore.getSelectedItems());
    this.active = true;
  }

  public update(input: RangeExtensionFrameInput): void {
    if (this.active) {
      this.roiFilteringEffects.applyDragSelection({
        indexPaths: input.indexPaths,
        cellsPerRow: input.cellsPerRow,
        snapshot: this.snapshot,
        modifiers: { shift: true, ctrlOrMeta: false, alt: false },
      });
      return;
    }

    this.roiFilteringEffects.selectRoisByIndexPaths({
      indexPaths: input.indexPaths,
      cellsPerRow: input.cellsPerRow,
    });
  }

  public end(): void {
    this.active = false;
    this.snapshot = new Set();
  }
}
